// extracted by mini-css-extract-plugin
export var editButton = "_ip-0";